import Vehicle from "../../../classes/Vehicle";
import { db } from "../../../boot/firebase";
import { collection, deleteDoc, doc, setDoc } from "firebase/firestore";

export const GET_VEHICLE = ({ dispatch }, id) => {
  return dispatch("GET_DOC", {
    converter: Vehicle,
    path: Vehicle.getPath(id),
    stateKey: "vehicles",
    id,
  });
};

export const GET_VEHICLES = (
  { dispatch },
  { conditions, limitCount, pagination }
) => {
  return dispatch("GET_COLLECTION", {
    converter: Vehicle,
    stateKey: "vehicles",
    path: Vehicle.getPath(),
    conditions,
    limitCount,
    pagination,
  });
};

export const LISTEN_VEHICLE = ({ dispatch }, { id, next, error, unlisten }) => {
  return dispatch("LISTEN_DOC", {
    converter: Vehicle,
    path: Vehicle.getPath(id),
    stateKey: "vehicles",
    id,
    next,
    error,
    unlisten,
  });
};

export const LISTEN_VEHICLES = (
  { dispatch },
  { next, pagination, error, unlisten }
) => {
  return dispatch("LISTEN_COLLECTION", {
    converter: Vehicle,
    path: Vehicle.getPath(),
    stateKey: "vehicles",
    pagination,
    next,
    error,
    unlisten,
  });
};

export const SAVE_VEHICLE = async ({ state }, vehicle) => {
  if (!vehicle.data.created) {
    // New Vehicle
    vehicle.data.created = new Date();
    vehicle.data.createdBy = state.user.id;

    const ref = doc(collection(db, Vehicle.getPath())).withConverter(Vehicle);
    vehicle.id = ref.id;

    await setDoc(ref, vehicle);
  } else {
    // Existing Vehicle
    vehicle.data.modified = new Date();
    vehicle.data.modifiedBy = state.user.id;
    await setDoc(doc(db, vehicle.path).withConverter(Vehicle), vehicle);
  }
  return vehicle;
};

export const DELETE_VEHICLE = async ({ commit }, id) => {
  await deleteDoc(doc(db, Vehicle.getPath(id)));
  commit("REMOVE", { stateKey: "vehicles", id });
};
